import { render, staticRenderFns } from "./DriverBottomMenu.vue?vue&type=template&id=1cd848b8&scoped=true&"
import script from "./DriverBottomMenu.vue?vue&type=script&lang=js&"
export * from "./DriverBottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./DriverBottomMenu.vue?vue&type=style&index=0&id=1cd848b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd848b8",
  null
  
)

export default component.exports